import { useRef, useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import { Link, useNavigate } from "react-router-dom";
import useApi from "../hooks/useApi";
import AuthService from "../services/auth.service";
import UserService from "../services/user.service";
import { syncWebToken } from "../utils/webPushSync";
import LanguageSwitcher from "./LanguageSwitcher";
import { Box, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useTranslation } from 'react-i18next';
import { API_BASE_URL, endpoints } from "../utils/utils";

const Login = () => {
  const { setAuth, persist, setPersist, auth } = useAuth();
  const { t, i18n } = useTranslation(['auth']);

  const navigate = useNavigate();
  const api = useApi();

  const userRef = useRef();
  const [user, setUser] = useState("");
  const [pwd, setPwd] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (!localStorage.getItem('i18nextLng')) {
      i18n.changeLanguage('fr');
    }
  }, [i18n]);

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [user, pwd]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await AuthService.login({ email: user, password: pwd }, api);
    if (response?.token) {
      const accessToken = response?.token;
      const roles = response?.user?.roles;
      const permissions = response?.user?.permissions;
      const refresh = response?.refresh_token;
      const active = response?.user?.status === 'ACTIVE';
      localStorage.setItem("accessToken", response?.token);
      let authToSet = { user: response?.user, roles, accessToken, permissions, refresh, active }
      setAuth(authToSet);

      if (response?.user?.id) {
        syncWebToken({
          userId: response.user.id,
          appName: "admin",
          axios: api,
        }).catch(() => {});
      }
      if (roles?.some((role) => role.name === "ROLE_HOTEL_MANAGER")) {
        navigate("/tasks", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }
  };

  return (
    <div className="main-login">
      <div className="container">
        <div className="admin-left">
          <div className="logo">flyspa</div>
          <div className="form-login">
            <div className="text-ou"></div>
            <form name="" id="" onSubmit={handleSubmit}>
              {errMsg ? <p className="error">{t('login.loginError')}</p> : ""}
              <div className="form-text">
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder={t('login.email')}
                  className="email"
                  ref={userRef}
                  autoComplete="off"
                  onChange={(e) => setUser(e.target.value)}
                  value={user}
                  required
                />
              </div>
              <div className="form-text password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  onChange={(e) => setPwd(e.target.value)}
                  name="password"
                  id="password"
                  value={pwd}
                  placeholder={t('login.password')}
                  className="password"
                  required
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={togglePasswordVisibility}
                  aria-label="toggle password visibility"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </button>

              </div>
              <Link to="/forget_password" className="pass-oublie">
                {t('login.forgotPassword')}
              </Link>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <div className="form-submit">
                  <input type="submit" name="sign" id="sign" value={t('login.loginButton')} />
                </div>
                <LanguageSwitcher />
              </Box>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
